export default {
  CARD: 'card',
}
